import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Store} from '@ngrx/store';
import {first, mergeMap, withLatestFrom} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {AppState} from '../core.state';
import {AuthSelectors} from '../stores/auth/selectors';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  baseHeaders = {
    'Content-Type': 'application/json; charset=utf-8',
    'X-App-Version': environment.appVersion,
  };

  headers: any = (environment.production) ? this.baseHeaders : {
    ...this.baseHeaders,
    // 'X-As-Dev-On': '1',
    // 'X-As-Dev-Pw': 'JackDev2590'
  };

  // l'interceptor funziona solo per il valore apiUrl principale
  urlCheckRegex = new RegExp(`${environment.apiUrl.replace('https://', '')}/${environment.apiVersion}`);

  constructor(
    private store: Store<AppState>) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return this.store.select(AuthSelectors.selectIsAuthenticated).pipe(
      first(),
      withLatestFrom(this.store.select(AuthSelectors.selectAuthToken)),
      mergeMap(([isAuthenticated, token]) => next.handle(req.clone({
        setHeaders: (isAuthenticated && this.urlCheckRegex.test(req.url)) ? {
          ...this.headers,
          Authorization: `Bearer ${token}`
        } : {}
      }))),
    );
  }

}
